/// <reference path="/js/lib/jquery/jquery-1.9.1.js"/>
/// <reference path="/js/lib/backbone.js"/>
/// <reference path="BaseSelectorView.js"/>

(function($, _) {
  var ns = window.nspace("ccc.viz.selectors");

  ns.DataTypeSelectorView = ns.BaseSelectorView.extend({
    name: "Data Type Selector",
    el: "#data-type-selector",
    template: _.template(
      [
        '<div class="filter-block data-type">',
        '<span class="filter-type-text">Data Type</span>',
        "<%",
        "if (dataFormats.length > 0) {",
        "var selectedItem = dataFormats.find(function (dataFormat) {",
        "return dataFormat.selected;",
        "});",
        "if (selectedItem === undefined) {",
        "dataFormats[0].selected = true;",
        "}",
        "}",
        "for (var i = 0; i < dataFormats.length; i++) {",
        "var format = dataFormats[i];",
        'var htmlId = _.str.sprintf("format-%s", format.id);',
        "if (format.selected) {",
        "%>",
        '<div class="radio-container">',
        '<input type="radio" name="dataTypeFilter" id="<%=htmlId%>" value="<%=format.id%>" data-name="<%=format.name%>" checked />',
        '<label for="<%=htmlId%>"><%=format.name%></label>',
        "</div>",
        "<%",
        "} else {",
        "%>",
        '<div class="radio-container">',
        '<input type="radio" name="dataTypeFilter" id="<%=htmlId%>" value="<%=format.id%>" data-name="<%=format.name%>" />',
        '<label for="<%=htmlId%>"><%=format.name%></label>',
        "</div>",
        "<%",
        "}",
        "%>",
        "<%",
        "}",
        "%>",
        "</div>"
      ].join("\n")
    ),
    propertyName: "dataFormatId",
    selectorInfoPropertyName: "dataFormats",

    initialize: function(options) {
      _.bindAll(
        this,
        "onChangeUpdateModel",
        "initializeModel",
        "updateDOM",
        "onBeforeChange",
        "getDataSummaryText"
      );

      this.getSelectorInfoFunc = options.getSelectorInfoFunc;

      // Handle the before change event so that we have an opportunity to update the
      // DataFormatId when the indicator ID changes. This will prevent multiple "change"
      // events from being emitted in response to changing the indicator.
      this.model.on("before-change", this.onBeforeChange);
    },

    events: {
      change: "onChangeUpdateModel"
    },

    onBeforeChange: function(newProps) {
      var self = this;

      // If the indicator ID is changing, then we need to also change the DFM ID
      if (this.model.get("indicatorId") !== newProps.indicatorId) {
        var allSelectorInfo = this.getSelectorInfoFunc();
        var selectorInfo = allSelectorInfo.selectors[newProps.indicatorId];

        var oldDfmId = self.model.get("dataFormatId");

        // If possible, keep the DFM ID the same (though this won't ever happen)
        var sameAsOld = _.where(selectorInfo.dataFormats, { id: oldDfmId });
        if (sameAsOld.length > 0) {
          return;
        }

        // Otherwise, data format IDs are indicator-specific, so when switching between indicators
        // we must match base on name, not ID
        var newDfm = _.find(selectorInfo.dataFormats, function(dfm) {
          return dfm.name === self.currentTypeName;
        });
        if (newDfm == null) {
          // No name-based match? Select the default, instead
          newDfm = selectorInfo.dataFormats[0];
        }

        // Record the newly selected type name
        self.currentTypeName = newDfm.name;

        // Update the newProps object to reflect our change
        newProps.dataFormatId = "" + newDfm.id;
      }
    },

    onChangeUpdateModel: function() {
      // Update the model
      var $radio = $("input:radio:checked", this.$el);
      this.model.set(this.propertyName, $radio.val());

      // Save the currently selected name, so we can match based on name when switching between indicators
      this.currentTypeName = $radio.data("name");

      // Tracks when a user changes the data type
      dataLayer.push({
        event: "Data Type Selection",
        eventCategory: "Data Type Selection",
        eventAction: "Data Type|" + $radio.attr("data-name"),
        eventLabel: window.location.pathname
      });
    },

    initializeModel: function() {
      // Update the model with the default selected item in the dropdown
      var $radio = $("input:radio:checked", this.$el);
      this.model.set(this.propertyName, $radio.val(), { silent: true });
      // Save the currently selected name, so we can match based on name when switching between indicators
      this.currentTypeName = $radio.data("name");
    },

    /**
     * Returns text summarizing the currently selected options for this selector.
     */
    getDataSummaryText: function() {
      var name = $(
        "input:radio[value='" + this.model.get(this.propertyName) + "']",
        this.$el
      ).data("name");

      // The DOM isn't guaranteed to be updated yet in cases where we're switching indicators, so fall back to the currentTypeName property
      return name == null ? this.currentTypeName : name;
    },

    updateDOM: function() {
      // Set the option corresponding to the value on the model
      $("input:radio[value='" + this.model.get(this.propertyName) + "']", this.$el).prop("checked", true);
    }
  });
})(jQuery, _);
